import { ItpxValidators } from './../../../shared/validators/itpx-validators';
import { Component } from '@angular/core';
import { FormGroup, FormBuilder, EmailValidator, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Observable, Subject } from 'rxjs/';

import { LicenseService } from '../../services/license.service';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '../../services/notification.service';
import { RxComponent } from '../../../shared/components/common/rx.component';

import { FlexibleDropdownConfig } from '../../../shared/components/flexible-dropdown/flexible-dropdown.component';
import { ReactiveFormComponent } from '../../../shared/components/reactive-form/reactive-form.component';
import { ProfileService } from '../profile/profile.service';
import { DomainService } from './../../services/domain.service';

declare var moment: any;

@Component({
    selector: 'itpx-register-with-voucher',
    templateUrl: './register-voucher.component.html',
    styleUrls: ['./register-voucher.component.css']
})
export class RegisterWtihVoucherComponent extends ReactiveFormComponent {

    private domain: any;
    private message;

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private profileService: ProfileService,
        private licenseService: LicenseService,
        private authService: AuthService,
        private notificationService: NotificationService,
        private domainService: DomainService,
        private validators: ItpxValidators
    ) {
        super();
    }

    ngOnInit() {

        this.domain = this.domainService.getDomain();

        this.form = this.fb.group({
            iVoucher: [null, [Validators.required]],
            username: [null, [Validators.required, ItpxValidators.emailValidator]],
        });

        super.ngOnInit();

        let formData = this.formSubmit.cacheResult();

        this.submitSuccess
            .withLatestFrom(formData, (_, formData) => formData)
            .do(_ => this.submitting.next(true))
            .bindToLifecycle(this)
            .subscribe(_ => {
                this.submitting.next(false);

                this.form.patchValue({
                  iVoucher: '',
                  username: ''
                }, {emitEvent:false});

                this.form.markAsPristine();

                this.message = {
                  type: 'success',
                  message: 'brandedPortal.redeemVoucher.emailSent'
                }
            }, err => {
              this.handleErrors(err);
            });
    }

    protected getFormSubmitQuery(data: any): Observable<any> {
        return this.licenseService.redeemVoucherRegistration({voucher: data.iVoucher, learner: data.username})
            .map(body => body.data)
            .catch((e: any) => Observable.throw(this.handleErrors(e.json())));
    }

    private handleErrors(e: any){
      this.message = {
        type: 'error',
        message: e.error.message.replace(e.error.code[0]+ ' ', '')
      }
    }

    private onRegister({ value, valid }: { value: any, valid: boolean }) {
        this.formSubmit.next(value);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/register-with-voucher/register-voucher.component.ts